// i18n.js
import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import enTranslation from "./locales/en.json";
// import esTranslation from "./locales/es.json";

const resources = {
  en: {
    translation: enTranslation,
  },
  //   es: {
  //     translation: esTranslation,
  //   },
};

i18n.use(initReactI18next).init({
  resources,
  lng: "en", // default language
  interpolation: {
    escapeValue: false, // react already safe from xss
  },
});

export default i18n;
